import React from "react";

// Elegant minimalist lawyer silhouette — classical bust style.
// Renders as a placeholder when a team member has no photo_url.
// Variant index (0..3) gives subtle compositional variation.
export default function LawyerSilhouette({ variant = 0, className = "" }) {
  const v = variant % 4;
  // gradient backgrounds — subtle navy/cream variations to give cards rhythm
  const bgGradients = [
    "linear-gradient(180deg, #EEF1F5 0%, #DDE3EC 100%)",
    "linear-gradient(180deg, #E5EAF0 0%, #CDD6E0 100%)",
    "linear-gradient(180deg, #EEF1F5 0%, #DDE3EC 100%)",
    "linear-gradient(180deg, #E5EAF0 0%, #CDD6E0 100%)",
  ];
  // alternate two silhouette poses
  const pose = v % 2;

  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`} style={{ background: bgGradients[v] }}>
      {/* subtle gold accent line top */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-[#C4A47C]/40" />

      {/* AP watermark backdrop */}
      <div
        aria-hidden
        className="absolute inset-0 flex items-center justify-center font-serif-ap text-[#0F2746]/[0.06] select-none"
        style={{ fontSize: "clamp(140px, 32vw, 320px)", letterSpacing: "-0.05em" }}
      >
        AP
      </div>

      {/* Silhouette */}
      <svg
        viewBox="0 0 300 400"
        className="absolute inset-x-0 bottom-0 w-full h-full"
        preserveAspectRatio="xMidYMax meet"
        aria-hidden
      >
        <defs>
          <linearGradient id={`sg-${v}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#0F2746" />
            <stop offset="100%" stopColor="#081A33" />
          </linearGradient>
        </defs>

        {pose === 0 ? (
          // Pose A: classic head + suit collar
          <g fill={`url(#sg-${v})`}>
            <ellipse cx="150" cy="155" rx="56" ry="64" />
            <path d="M58 400 Q60 290 110 262 L150 248 L190 262 Q240 290 242 400 Z" />
            {/* shirt + tie hint */}
            <path d="M138 268 L150 290 L162 268 L156 400 L144 400 Z" fill="#F3F5F8" opacity="0.92" />
            <path d="M148 290 L150 296 L152 290 L154 380 L146 380 Z" fill="#C4A47C" opacity="0.85" />
          </g>
        ) : (
          // Pose B: slightly different shoulder line
          <g fill={`url(#sg-${v})`}>
            <ellipse cx="150" cy="148" rx="52" ry="60" />
            <path d="M64 400 Q66 286 116 258 L150 244 L184 258 Q234 286 236 400 Z" />
            <path d="M132 264 Q150 282 168 264 L168 400 L132 400 Z" fill="#F3F5F8" opacity="0.94" />
            {/* lapel notch */}
            <path d="M150 270 L138 280 L150 295 L162 280 Z" fill="#0F2746" opacity="0.9" />
          </g>
        )}
      </svg>
    </div>
  );
}
